import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "found-card" }
const _hoisted_2 = { class: "found-icon" }
const _hoisted_3 = { class: "found-info" }
const _hoisted_4 = { class: "count" }

import { Icon } from "@/components/ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsFoundCard',
  props: {
    contactsCount: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Icon), {
        icon: "fluent-mdl2:people-add",
        class: "icon"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.contactsCount) + " contacts found", 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "status" }, "Ready to enrich and import", -1))
    ])
  ]))
}
}

})